<template>
  <el-form :model="form" label-width="0">
    <el-form-item :error="errors.username">
      <el-input ref="username" v-model="form.username" placeholder="账号" autofocus>
        <svg-icon slot="prepend" icon-class="user" />
      </el-input>
    </el-form-item>
    <el-form-item :error="errors.password">
      <el-input v-model="form.password" placeholder="密码" type="password">
        <svg-icon slot="prepend" icon-class="password" />
      </el-input>
    </el-form-item>
    <el-form-item v-if="loginCaptcha" prop="captcha" :error="errors.captcha">
      <space>
        <el-input ref="captchaInput" v-model="form.captcha" placeholder="验证码"><svg-icon slot="prepend" icon-class="captcha"/></el-input>
        <div class="captcha"><captcha ref="captcha" @captcha="getCaptchaConfig" config="admin" /></div>
      </space>
    </el-form-item>
  </el-form>
</template>

<script>
import { getMessage } from '@/libs/utils'
import Captcha from '@c/Captcha'
import Space from '@c/Space'
import { SYSTEM_BASIC } from '@/libs/constants'

export default {
  name: 'LoginForm',
  components: {
    Captcha,
    Space,
  },
  data: () => ({
    form: {
      username: '',
      password: '',
      captcha: '',
      key: '',
    },
    errors: {},
  }),
  computed: {
    loginCaptcha() {
      const v = this.$store.getters.getConfig(
        SYSTEM_BASIC.SLUG + '.' + SYSTEM_BASIC.ADMIN_LOGIN_CAPTCHA_SLUG,
        SYSTEM_BASIC.DEFAULT_ADMIN_LOGIN_CAPTCHA,
      )
      return Boolean(Number(v))
    },
  },
  mounted() {
    this.$refs.username.focus()
  },
  methods: {
    async onSubmit() {
      await this.$store.dispatch('login', this)
      this.$message.success(getMessage('loggedIn'))
    },
    async getCaptchaConfig(captcha) {
      this.form.key = captcha.key
    },
    focusWhenError(e) {
      if (e.response.status !== 422) {
        return
      }

      const errors = e.response.data.errors

      // 如果只是验证码错了，则聚焦验证码
      // 否则聚焦用户名
      if (Object.keys(errors).length === 1 && errors.captcha) {
        this.$refs.captchaInput.focus()
        this.$refs.captchaInput.$refs.input.select()
      } else {
        this.$refs.username.focus()
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep {
  .el-input-group__prepend {
    padding: 0 12px;
  }
}
</style>
